import { render, staticRenderFns } from "./editAffiliate.vue?vue&type=template&id=065ab4e4&lang=pug"
import script from "./editAffiliate.vue?vue&type=script&lang=js"
export * from "./editAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports